<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close()">
    <v-card>
      <v-card-title class="pt-4">Create Su Table</v-card-title>
      <v-card-text class="pl-4 pt-0">
        <FormRHDHV
          ref="form"
          :url="strippedUrl"
          :model="model"
          :formOrder="fields"
          :dialog="dialog"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" color="primary" text @click="addSuTable()"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormRHDHV from '@/components/form/FormRHDHV.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CreateSuTableDialog.',
  components: { FormRHDHV },
  data: () => ({
    model: null
  }),
  computed: {
    ...mapState('suTable', {
      baseUrl: (state) => state.baseUrl,
      loading: (state) => state.loading,
      dialog: (state) => state.dialog,
      fields: (state) => state.fields,
      baseItem: (state) => state.baseItem
    }),
    strippedUrl() {
      return this.baseUrl.replaceAll('/', '')
    }
  },
  methods: {
    ...mapActions('suTable', {
      toggleDialog: 'toggleDialog',
      add: 'add',
      create: 'create'
    }),
    ...mapGetters('project', {
      selectedProjectId: 'selectedProjectId'
    }),
    ...mapGetters('suTable', {
      getEmptyItem: 'getEmptyItem'
    }),
    async addSuTable() {
      this.model.project = this.selectedProjectId()
      await this.add(this.model)
      await this.create()
      this.toggleDialog()
      this.model.name = ''
    },
    close() {
      this.toggleDialog()
    }
  },
  async mounted() {
    this.model = this.baseItem
  }
}
</script>
